module.exports = __webpack_public_path__ + "static/media/eye.26980e40.svg";